import React, { useState } from 'react'
import { getFromStorage, setInStorage } from '../storage'

export default function useRememberedState<T>(
  key: string,
  userScoped: boolean,
  defaultValue: T
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [state, setState] = useState<T>(() => {
    // Lazy initialization because local storage is io-bound.
    // Avoids the return value (state) flickering.
    const fromStorage = getFromStorage(key, userScoped)
    return fromStorage === null ? defaultValue : fromStorage
  })

  const wrappedSetState = value => {
    setState(value)
    setInStorage(key, value, userScoped)
  }

  return [state, wrappedSetState]
}
